import { useCallback } from 'react';

export const useScrollToSection = () => {
    const scrollToSection = useCallback((sectionId: string) => {
        const section = document.querySelector(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, []);

    const handleNavClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
            e.preventDefault();
            scrollToSection(sectionId);
        },
        [scrollToSection]
    );

    return { scrollToSection, handleNavClick };
};
